import { ReactNode } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, TextField, useTheme, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/i18n/types/i18nNamespace';
import { I18nCommonNs } from '@/i18n/dictionaries/interfaces';
import { OrangePrimaryButton } from '../form/OrangePrimaryButton';

type ConfirmDialogProps = {
  open: boolean;
  title?: string;
  children: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonDisabled?: boolean;
  cancelButtonDisabled?: boolean;
  confirmLoading?: boolean;
};

const ConfirmDialog = ({
  open,
  title,
  children,
  onConfirm,
  onCancel,
  confirmButtonDisabled,
  cancelButtonDisabled,
  confirmLoading
}: ConfirmDialogProps) => {
  const [translate] = useTranslation([I18nNamespace.Common]);
  const theme = useTheme();


  return (
    <Dialog
      open={open}
      onClose={(_, _reason) => {
        if (confirmLoading) {
          return;
        }
        onCancel();
      }}
      disableEscapeKeyDown={confirmLoading}
      sx={{
        '& .MuiDialog-paper': {
          width: '80%',
          backgroundColor: theme.palette.grey[50],
          borderRadius: theme.spacing(1),
        }
      }}>
      {!!title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        <OrangePrimaryButton onClick={onCancel} variant="outlined" disabled={cancelButtonDisabled || confirmLoading}>
          {translate(nameof.full<I18nCommonNs>((n) => n.buttonLabels.cancel))}
        </OrangePrimaryButton>
        <OrangePrimaryButton
          onClick={onConfirm}
          variant="contained"
          disabled={confirmButtonDisabled || confirmLoading}
        >
          {confirmLoading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            translate(nameof.full<I18nCommonNs>((n) => n.buttonLabels.confirm))
          )}
        </OrangePrimaryButton>
      </DialogActions>
    </Dialog >
  );
};

export default ConfirmDialog;
